import { render } from "./TransportInvoicesPage.vue?vue&type=template&id=0b8a5ab6&ts=true"
import script from "./TransportInvoicesPage.vue?vue&type=script&lang=ts"
export * from "./TransportInvoicesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__